import React, { useMemo } from 'react'
import { Grid, Typography } from '@the-platform-group/component-library'
import { usePeopleMergeContext } from 'pages/MergeProfiles/contexts/PeopleMergeContext'
import MappedJobAccordion from './MappedJobAccordion'

/**
 * MappedJobsSection - Displays list of all mapped jobs in the final review step
 * Shows all job mappings created in Step 2, displayed as expandable accordions.
 * @param {Object} props
 * @param {Function} props.onEditMapping - Callback to edit a mapping (sourceJobIds, targetJobId)
 * @param {Function} props.onViewDetails - Callback to view full details (targetJobId)
 *
 * @returns {React.Component|null} Section with accordion list or null if no mapped jobs
 */
const MappedJobsSection = ({ onEditMapping, onViewDetails }) => {
  const { mergeData, jobMappingData } = usePeopleMergeContext()
  const { targetJobs } = mergeData.selectedData
  const { mappedTargetJobIds } = jobMappingData

  const mappedJobs = useMemo(() => {
    return targetJobs.filter(job => mappedTargetJobIds.includes(job.id))
  }, [targetJobs, mappedTargetJobIds])

  if (mappedJobs.length === 0) {
    return null
  }

  return (
    <Grid container>
      <Grid
        item
        container
        sx={{
          backgroundColor: 'background.secondary.default',
          borderBottom: '1px solid',
          borderColor: 'border.interactive',
        }}
      >
        <Grid item xs={4} sx={{ p: 2 }}>
          <Typography variant="body2" fontWeight="bold">
            Mapped jobs
          </Typography>
        </Grid>
        <Grid item xs={8} />
      </Grid>

      {mappedJobs.map(job => (
        <MappedJobAccordion
          key={job.id}
          targetJob={job}
          onEdit={onEditMapping}
          onViewDetails={onViewDetails}
        />
      ))}
    </Grid>
  )
}

export default MappedJobsSection
